import React from "react";
import { QueryInfo } from "system/query/QueryInfo";
import { QueryBuilderValueBox } from "./QueryBuilderValueBox";
import { Box } from "@mui/material";
import { QueryBuilderInnerLabel } from "./QueryBuilderInnerLabel";

export interface QueryBuilderFieldLabelProps {
  fieldId: string | undefined;
  multiFieldIds?: string[] | undefined;
  queryInfo: QueryInfo;
  borderColor?: string;
  borderColorTop?: string;
  inline?: boolean;
  isViewerMode?: boolean;
}

export function QueryBuilderFieldLabel(props: QueryBuilderFieldLabelProps): JSX.Element {

  const fieldIds = props.multiFieldIds || [props.fieldId];
  const fieldLabels = fieldIds?.map(field_id => {
    return props.queryInfo?.fields?.find(field => field.id === field_id)?.label || field_id;
  });

  const fieldDisplays = fieldLabels.map((fieldLabel, index) => {
    return (
      <Box sx={{display: "inline"}} key={index}>
        <QueryBuilderValueBox
          label={fieldLabel}
          isViewerMode={props.isViewerMode}
          borderColor={props.borderColor}
          borderColorTop={props.borderColorTop}
          inline={true}
        />
        {index < fieldLabels.length - 1 &&
          <QueryBuilderInnerLabel>or</QueryBuilderInnerLabel>
        }
      </Box>
    );
  });

  return (
    <>{fieldDisplays}</>
  );
}
